export default {"src":"/_next/static/media/HK.7fbd5587.svg","height":35,"width":53,"blurWidth":0,"blurHeight":0};